import { useQuery } from '@tanstack/react-query';
import API, { eventsApiUrl as EventQK, eventsLocationsApiUrl as LocationUrl } from './events-api';
import { ResponseType } from 'src/constants/data';

export const useGetEvent = (slug: string | undefined) => {
  return useQuery({
    queryKey: [EventQK, ResponseType.Single, slug],
    queryFn: () => API.getEvent(slug),
    enabled: !!slug
  });
};

export const useGetEventsLocations = () => {
  return useQuery({
    queryKey: [LocationUrl],
    queryFn: () => API.getEventsLocations()
  });
};

export const useGetEvents = () => {
  return useQuery({
    queryKey: [EventQK, ResponseType.List],
    queryFn: () => API.getEvents()
  });
};
